/**
 * Delivery: drivers, runs, per-stop outcomes (README.md Phase 22). A run is
 * created and dispatched in one action — no separate draft state — since the
 * whole point is the run sheet + every stop's slip PDF gets generated the
 * moment the orders actually leave the shop.
 */
import { z } from 'zod';
import { idSchema, paginationSchema, paisaSchema } from './common.js';
export const createDriverSchema = z.object({
    name: z.string().min(1).max(120),
    phone: z.string().max(20).optional(),
    vehicleInfo: z.string().max(120).optional(),
});
export const updateDriverSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    phone: z.string().max(20).nullable().optional(),
    vehicleInfo: z.string().max(120).nullable().optional(),
    isActive: z.boolean().optional(),
});
export const listDriversQuerySchema = paginationSchema.extend({
    isActive: z.coerce.boolean().optional(),
});
export const createRunSchema = z.object({
    shopId: idSchema,
    /** Omit for a self-shipped run — no driver assigned. */
    driverId: idSchema.optional(),
    /** Stop order — index position is the stop sequence. */
    orderIds: z.array(idSchema).min(1).max(100),
});
export const listRunsQuerySchema = paginationSchema.extend({
    shopId: idSchema.optional(),
    status: z.enum(['DISPATCHED', 'COMPLETED']).optional(),
});
export const recordStopOutcomeSchema = z
    .object({
    outcome: z.enum(['DELIVERED', 'FAILED']),
    /** Cash actually collected at the door — only meaningful for a COD order marked DELIVERED. */
    codCollectedPaisa: paisaSchema.min(0).optional(),
    failureReason: z.string().max(300).optional(),
})
    .refine((v) => v.outcome !== 'FAILED' || !!v.failureReason?.trim(), {
    message: 'A reason is required for a failed stop',
    path: ['failureReason'],
});
//# sourceMappingURL=delivery.js.map